// TeraMart Pulse — AJAX cart + live filters + quick-view + skeleton
(function(){
  'use strict';

  const FREE_SHIP_THRESHOLD = 20000; // cents (A$200) — matches theme setting default
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const moneyFormat = (cents) => 'A$' + (cents / 100).toFixed(2);

  // ---------------- Toast ----------------
  const toast = $('[data-toast]');
  const toastInner = $('[data-toast-inner]');
  let toastTimer;
  function showToast(html, kind) {
    if (!toast || !toastInner) return;
    toastInner.innerHTML = html;
    toast.dataset.kind = kind || 'ok';
    toast.hidden = false;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => (toast.hidden = true), 260);
    }, 3000);
  }

  // ---------------- Cart drawer ----------------
  const drawer = $('[data-cart-drawer]');
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => (drawer.hidden = true), 260);
  }
  $$('[data-cart-drawer-close]').forEach(el => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer(); });

  // Open drawer when clicking the header cart icon (keeps /cart as fallback via SHIFT+click)
  $$('a[href*="/cart"]').forEach(link => {
    if (link.closest('.m-bottomnav, [data-cart-drawer]')) return; // skip bottom nav + checkout button
    link.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      openDrawer();
    });
  });

  // ---------------- Cart state refresh ----------------
  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.ok ? r.json() : null;
  }
  function updateShipbar(cart) {
    const bar = $('[data-cart-shipbar]'), fill = $('[data-cart-shipbar-fill]'), txt = $('[data-cart-shipbar-text]');
    if (!bar || !cart) return;
    if (cart.item_count === 0) { bar.hidden = true; return; }
    bar.hidden = false;
    const progress = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);
    if (fill) fill.style.width = progress + '%';
    if (cart.total_price >= FREE_SHIP_THRESHOLD) {
      if (txt) txt.innerHTML = '✓ You qualify for free shipping';
      bar.classList.add('is-unlocked');
    } else {
      const remaining = FREE_SHIP_THRESHOLD - cart.total_price;
      if (txt) txt.textContent = `Add ${moneyFormat(remaining)} to unlock free shipping`;
      bar.classList.remove('is-unlocked');
    }
  }
  function refreshCartCount(cart) {
    $$('[data-cart-count], .topbar__count, .m-bottomnav__cart em').forEach(el => {
      const n = cart.item_count;
      el.textContent = n;
      el.hidden = n === 0;
    });
    $$('[data-cart-drawer-count]').forEach(el => el.textContent = `(${cart.item_count})`);
    $$('[data-cart-subtotal]').forEach(el => el.textContent = moneyFormat(cart.total_price));
  }
  async function renderDrawerBody() {
    const body = $('[data-cart-drawer-body]');
    if (!body) return;
    const r = await fetch('/cart?view=drawer-body', { headers: { 'Accept': 'text/html' } });
    if (!r.ok) return;
    // Shopify ?view= rendering — falls back to full page if template doesn't exist.
    // We re-query /cart.js and rebuild manually for predictability:
    const cart = await fetchCart();
    if (!cart) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--outline">Browse products</a></div>';
      const footer = $('.cart-drawer__footer');
      if (footer) footer.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map((item, idx) => `
      <div class="cart-item" data-cart-item data-line="${idx + 1}">
        <a href="${item.url}" class="cart-item__media">${item.image ? `<img src="${item.image}" width="96" height="96" alt="" loading="lazy">` : ''}</a>
        <div class="cart-item__body">
          <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${moneyFormat(item.final_price)}</div>
          <div class="cart-item__qty" data-qty>
            <button type="button" class="cart-item__qty-btn" data-cart-qty="-1" data-line="${idx + 1}">−</button>
            <input type="number" value="${item.quantity}" min="0" data-cart-qty-input data-line="${idx + 1}">
            <button type="button" class="cart-item__qty-btn" data-cart-qty="1" data-line="${idx + 1}">+</button>
          </div>
        </div>
        <button type="button" class="cart-item__remove" data-cart-remove data-line="${idx + 1}" aria-label="Remove">✕</button>
      </div>
    `).join('');
    const footer = $('.cart-drawer__footer');
    if (footer) {
      footer.hidden = false;
      footer.querySelector('button[name=checkout]').textContent = `Checkout — ${moneyFormat(cart.total_price)}`;
    }
    bindCartLineHandlers();
  }
  async function updateLine(line, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!r.ok) return;
    const cart = await r.json();
    refreshCartCount(cart);
    updateShipbar(cart);
    renderDrawerBody();
  }
  function bindCartLineHandlers() {
    $$('[data-cart-qty]').forEach(btn => btn.addEventListener('click', () => {
      const line = parseInt(btn.dataset.line, 10);
      const delta = parseInt(btn.dataset.cartQty, 10);
      const input = $(`[data-cart-qty-input][data-line="${line}"]`);
      const newQty = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      input.value = newQty;
      updateLine(line, newQty);
    }));
    $$('[data-cart-qty-input]').forEach(inp => inp.addEventListener('change', () => {
      updateLine(parseInt(inp.dataset.line, 10), parseInt(inp.value, 10) || 0);
    }));
    $$('[data-cart-remove]').forEach(btn => btn.addEventListener('click', () => {
      updateLine(parseInt(btn.dataset.line, 10), 0);
    }));
  }
  bindCartLineHandlers();

  // ---------------- AJAX Add-to-cart ----------------
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const submitBtn = form.querySelector('button[type=submit], input[type=submit]');
    const origLabel = submitBtn ? submitBtn.innerHTML : null;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = '<span class="spinner"></span> Adding…'; }
    try {
      const data = new FormData(form);
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      });
      if (!r.ok) throw new Error('Add failed');
      const added = await r.json();
      const cart = await fetchCart();
      refreshCartCount(cart);
      updateShipbar(cart);
      renderDrawerBody();
      showToast(`<strong>Added to cart:</strong> ${added.product_title || 'Item'}`, 'ok');
      // Optionally open drawer:
      setTimeout(openDrawer, 200);
    } catch (err) {
      showToast('Could not add to cart. Please try again.', 'error');
    } finally {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = origLabel; }
    }
  });

  // ---------------- AJAX collection filters ----------------
  const filterForm = $('#CollectionFiltersForm');
  const collectionGrid = $('.collection-grid');
  const collectionMain = $('.collection-main');
  if (filterForm && collectionGrid) {
    const applyFilter = async () => {
      const params = new URLSearchParams(new FormData(filterForm));
      const url = window.location.pathname + '?' + params.toString();
      // Show skeleton
      collectionGrid.classList.add('is-loading');
      try {
        const r = await fetch(url);
        if (!r.ok) throw new Error('Filter failed');
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('.collection-grid');
        const newSidebar = doc.querySelector('.collection-sidebar__form');
        const newCount = doc.querySelector('.collection-tools__count');
        if (newGrid) collectionGrid.replaceWith(newGrid);
        if (newSidebar && filterForm.parentElement) {
          // Replace the form so updated active filters + counts show
          filterForm.innerHTML = newSidebar.innerHTML;
        }
        if (newCount) {
          const currentCount = $('.collection-tools__count');
          if (currentCount) currentCount.replaceWith(newCount);
        }
        window.history.pushState({}, '', url);
        // Re-bind listeners for new inputs
        setupFilterListeners();
      } catch (err) {
        console.warn('Filter AJAX failed, reloading:', err);
        window.location.href = url;
      }
    };
    const setupFilterListeners = () => {
      const form = $('#CollectionFiltersForm');
      if (!form) return;
      form.addEventListener('submit', e => { e.preventDefault(); applyFilter(); });
      $$('input, select', form).forEach(inp => {
        inp.removeAttribute('onchange');
        inp.addEventListener('change', applyFilter);
      });
    };
    setupFilterListeners();
  }

  // ---------------- Quick-view modal ----------------
  // Trigger via [data-quick-view] on product cards (optional for merchants to add)
  $$('[data-quick-view]').forEach(el => {
    el.addEventListener('click', async (e) => {
      e.preventDefault();
      const handle = el.dataset.quickView;
      try {
        const r = await fetch(`/products/${handle}.js`);
        if (!r.ok) return;
        const p = await r.json();
        const html = `
          <div class="quick-view__media"><img src="${p.featured_image || ''}" alt="${p.title}" width="400" height="400"></div>
          <div class="quick-view__body">
            <h3>${p.title}</h3>
            <div class="quick-view__price">${moneyFormat(p.price)}</div>
            <p>${p.description || ''}</p>
            <a href="${p.url}" class="btn btn--accent">View full details</a>
          </div>`;
        let modal = $('[data-quick-view-modal]');
        if (!modal) {
          modal = document.createElement('div');
          modal.className = 'quick-view';
          modal.setAttribute('data-quick-view-modal', '');
          modal.innerHTML = `<div class="quick-view__backdrop" data-qv-close></div><div class="quick-view__panel"></div>`;
          document.body.appendChild(modal);
          modal.addEventListener('click', ev => { if (ev.target.matches('[data-qv-close]')) modal.remove(); });
        }
        modal.querySelector('.quick-view__panel').innerHTML = `<button type="button" class="quick-view__close" data-qv-close aria-label="Close">✕</button>${html}`;
      } catch(e) {}
    });
  });

  // Initial shipbar update
  fetchCart().then(c => { if (c) updateShipbar(c); });
})();
